import jQuery from 'jquery';

function Directive() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      loading: '=',
      dark: '='
    },
    template: `<div ng-class="{ 'loading-dots-dark' : dark, 'loading-dots' : !dark }">
      <div class="loader">
        <div class="circle">&nbsp;</div>
        <div class="circle">&nbsp;</div>
        <div class="circle">&nbsp;</div>
        <div class="circle">&nbsp;</div>
      </div>
    </div>`,
    link(scope, element) {
      scope.$watch('loading', function(val) {
        if (val) {
          jQuery(element).show();
        } else {
          jQuery(element).hide();
        }
      });
    }
  };
}

Directive.$inject = [];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/loadingDots/index.js